import _regeneratorRuntime from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/regenerator";
import "core-js/modules/es6.regexp.split";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/asyncToGenerator";
import _classCallCheck from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/classCallCheck";
import _createClass from "D:\\a\\1\\s\\AMRS\\AMRS.Web\\ClientApp\\node_modules\\@babel\\runtime-corejs2/helpers/createClass";
import axios from "axios";
import { OperatingReserve } from ".";

var OperatingReserveData =
/*#__PURE__*/
function () {
  function OperatingReserveData() {
    _classCallCheck(this, OperatingReserveData);
  }

  _createClass(OperatingReserveData, [{
    key: "CheckForDuplicates",
    value: function () {
      var _CheckForDuplicates = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(invoiceNum, invoiceDate, vendorId, index, amount) {
        var dateArray, date;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dateArray = invoiceDate.split("/");
                date = dateArray[1] + "-" + dateArray[2] + "-" + dateArray[0];
                return _context.abrupt("return", axios.get("/api/CheckForDuplicates/".concat(invoiceNum, "/").concat(date, "/").concat(vendorId, "/").concat(index, "/").concat(amount)));

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function CheckForDuplicates(_x, _x2, _x3, _x4, _x5) {
        return _CheckForDuplicates.apply(this, arguments);
      }

      return CheckForDuplicates;
    }()
  }, {
    key: "GetProperty_List",
    value: function () {
      var _GetProperty_List = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(isAdmin, userId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt("return", axios.get("/api/GetOperatingPropertyList/".concat(isAdmin, "/").concat(userId)));

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function GetProperty_List(_x6, _x7) {
        return _GetProperty_List.apply(this, arguments);
      }

      return GetProperty_List;
    }()
  }, {
    key: "GetOperating_List",
    value: function () {
      var _GetOperating_List = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(isAdmin, userId, projectId) {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                return _context3.abrupt("return", axios.get("/api/GetOperatingList/".concat(isAdmin, "/").concat(userId, "/").concat(projectId)));

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function GetOperating_List(_x8, _x9, _x10) {
        return _GetOperating_List.apply(this, arguments);
      }

      return GetOperating_List;
    }()
  }, {
    key: "GetTypes",
    value: function () {
      var _GetTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", axios.get("/api/GetTypes/"));

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function GetTypes() {
        return _GetTypes.apply(this, arguments);
      }

      return GetTypes;
    }()
  }, {
    key: "GetReviewTypes",
    value: function () {
      var _GetReviewTypes = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee5() {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                return _context5.abrupt("return", axios.get("/api/GetReviewTypes/"));

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function GetReviewTypes() {
        return _GetReviewTypes.apply(this, arguments);
      }

      return GetReviewTypes;
    }()
  }, {
    key: "AdminChangeStatus",
    value: function () {
      var _AdminChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee6(requestId, StatusId) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", axios.get("api/AdminChangeStatusORR/".concat(requestId, "/").concat(StatusId)));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function AdminChangeStatus(_x11, _x12) {
        return _AdminChangeStatus.apply(this, arguments);
      }

      return AdminChangeStatus;
    }()
  }, {
    key: "SaveReplacement",
    value: function () {
      var _SaveReplacement = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee7(tableData, status, requestId, projectId, deleteIndexes, itemDeleteIndexes, userId, submittedAsException, reserveTypeId, processingInstructions) {
        var items, operatingRequest;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                items = [];
                tableData.forEach(function (x) {
                  return items.push({
                    OperatingReserveRequestItem_Id: x.itemId,
                    CheckNumber: x.checkNum,
                    Reason: x.reason,
                    Payee: x.payee,
                    Description: x.description,
                    AdditionalDescription: x.additionalDescription,
                    OtherDescription: x.otherDescription,
                    OperatingReserveRequestType_Id: x.type ? x.type.operatingReserveItemType_Id : null,
                    InvoiceDate: x.invoiceDate,
                    InvoiceNumber: x.invoiceNum,
                    DuplicateInvoiceComment: x.comments,
                    ClaimedAmount: x.money,
                    Location: x.unitNum,
                    PayVendorDirectly: x.payDirectly,
                    NewVendor: x.newVendor,
                    Vendor_Id: x.vendor_Id,
                    HeadOfHousehold: x.headOfHousehold,
                    Income: x.income,
                    EffectiveDate: x.effectiveDate,
                    NumInHousehold: x.numInHousehold,
                    ServiceRequested: x.serviceRequested
                  });
                });
                operatingRequest = {
                  OperatingReserveRequest_Id: requestId,
                  Project_Id: projectId,
                  StatusId: status,
                  OperatingReserveRequestItem: items,
                  RequestContact_Id: userId,
                  SubmittedAsException: submittedAsException,
                  ReserveTypeId: reserveTypeId,
                  ProcessingInstructions: processingInstructions
                };
                return _context7.abrupt("return", axios.post("/api/saveOperatingProgress", {
                  operatingRequest: operatingRequest,
                  deleteIndexes: deleteIndexes,
                  itemDeleteIndexes: itemDeleteIndexes
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function SaveReplacement(_x13, _x14, _x15, _x16, _x17, _x18, _x19, _x20, _x21, _x22) {
        return _SaveReplacement.apply(this, arguments);
      }

      return SaveReplacement;
    }()
  }, {
    key: "SaveReview",
    value: function () {
      var _SaveReview = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee8(reviewData, requestId, deleteReviewIndexes, vacancy, netIncome, mhdcComments, operatingBalance, sufficientFunds, waitingOnProject, approvedAmounts, userId, reserveTypeId, processingInstructions) {
        var items, operatingRequest;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                items = [];
                reviewData.forEach(function (x) {
                  return items.push({
                    OperatingReserveReviewItem_Id: x.id,
                    Amount: x.amount,
                    Description: x.description,
                    Type_Id: x.type ? x.type.type_Id : null
                  });
                });
                operatingRequest = {
                  OperatingReserveRequest_Id: requestId,
                  OperatingReserveReviewItem: items,
                  Vacancy: vacancy,
                  NetIncomeOrLoss: netIncome,
                  MhdcComments: mhdcComments,
                  OperatingBalance: operatingBalance,
                  SufficientFunds: sufficientFunds.value,
                  WaitingOnProject: waitingOnProject,
                  ApprovedById: userId,
                  ReserveTypeId: reserveTypeId,
                  ProcessingInstructions: processingInstructions
                };
                return _context8.abrupt("return", axios.post("/api/saveOperatingReview", {
                  operatingRequest: operatingRequest,
                  deleteIndexes: deleteReviewIndexes,
                  approvedAmounts: approvedAmounts
                }));

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function SaveReview(_x23, _x24, _x25, _x26, _x27, _x28, _x29, _x30, _x31, _x32, _x33, _x34, _x35) {
        return _SaveReview.apply(this, arguments);
      }

      return SaveReview;
    }()
  }, {
    key: "GetRequest",
    value: function () {
      var _GetRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee9(requestId, projectId, isAdmin) {
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt("return", axios.get("/api/GetOperatingRequest/".concat(requestId, "/").concat(projectId, "/").concat(isAdmin)));

              case 1:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function GetRequest(_x36, _x37, _x38) {
        return _GetRequest.apply(this, arguments);
      }

      return GetRequest;
    }()
  }, {
    key: "ChangeStatus",
    value: function () {
      var _ChangeStatus = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee10(status, requestId, userId, vacancy, netIncome, reviewData, deleteReviewIndexes, mhdcComments, operatingBalance, sufficientFunds, approvedAmounts, processingInstructions) {
        var items, operatingRequest;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                items = [];
                reviewData.forEach(function (x) {
                  return items.push({
                    OperatingReserveReviewItem_Id: x.id,
                    Amount: x.amount,
                    Description: x.description,
                    Type_Id: x.type ? x.type.type_Id : null
                  });
                });
                operatingRequest = {
                  OperatingReserveReviewItem: items,
                  Vacancy: vacancy,
                  NetIncomeOrLoss: netIncome,
                  MhdcComments: mhdcComments,
                  OperatingBalance: operatingBalance,
                  SufficientFunds: sufficientFunds.value,
                  ProcessingInstructions: processingInstructions
                };
                return _context10.abrupt("return", axios.post("/api/ChangeOperatingStatus", {
                  statusID: status,
                  requestId: requestId,
                  userId: userId,
                  approvedAmounts: approvedAmounts,
                  orrequest: operatingRequest,
                  deleteIndexes: deleteReviewIndexes
                }));

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function ChangeStatus(_x39, _x40, _x41, _x42, _x43, _x44, _x45, _x46, _x47, _x48, _x49, _x50) {
        return _ChangeStatus.apply(this, arguments);
      }

      return ChangeStatus;
    }()
  }, {
    key: "Download",
    value: function () {
      var _Download = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee11(fileId) {
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                return _context11.abrupt("return", axios.get("/api/OperatingDownload/".concat(fileId)));

              case 1:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function Download(_x51) {
        return _Download.apply(this, arguments);
      }

      return Download;
    }()
  }, {
    key: "UploadFile",
    value: function () {
      var _UploadFile = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee12(files, projectId, requestId, fileName) {
        var formData;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                formData = new FormData();
                files.forEach(function (file) {
                  formData.append("files[]", file);
                });
                formData.append("projectId", projectId);
                formData.append("requestId", requestId);
                formData.append("fileName", fileName);
                return _context12.abrupt("return", axios.post("/api/OperatingReserveFileUpload", formData, {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }));

              case 6:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function UploadFile(_x52, _x53, _x54, _x55) {
        return _UploadFile.apply(this, arguments);
      }

      return UploadFile;
    }()
  }, {
    key: "UnSubmitRequest",
    value: function () {
      var _UnSubmitRequest = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee13(requestId) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                return _context13.abrupt("return", axios.post("api/OperatingReserve/UnSubmit", requestId, {
                  headers: {
                    "Content-Type": "application/json"
                  }
                }));

              case 1:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function UnSubmitRequest(_x56) {
        return _UnSubmitRequest.apply(this, arguments);
      }

      return UnSubmitRequest;
    }()
  }, {
    key: "CopyW9s",
    value: function () {
      var _CopyW9s = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee14(requestId) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                return _context14.abrupt("return", axios.post("/api/OperatingReserve/CopyW9s/".concat(requestId)));

              case 1:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function CopyW9s(_x57) {
        return _CopyW9s.apply(this, arguments);
      }

      return CopyW9s;
    }()
  }]);

  return OperatingReserveData;
}();

export default new OperatingReserveData();